import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-ag-common-buttons',
  templateUrl: './ag-common-buttons.component.html',
  styleUrls: ['./ag-common-buttons.component.scss']
})
export class AgCommonButtonsComponent implements OnInit, ICellRendererAngularComp {

  constructor() { }
  params: any;
  type: string = '';

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    this.type = (params.data?.type || '').trim();
  }

  refresh(params: ICellRendererParams<any, any>): any {
    // throw new Error('Method not implemented.');
    return
  }

  ngOnInit(): void { }

  onCreatePart() {
    // send gridId to identify which grid triggered the event
    const customEvent = new CustomEvent('createPartClick', {
      detail: { data: this.params, gridId: this.params?.context?.storageName },
    });
    document.dispatchEvent(customEvent);
  }

  onApproveAlt() {
    // send gridId to identify which grid triggered the event
    const customEvent = new CustomEvent('approveAltClick', {
      detail: { data: this.params, gridId: this.params?.context?.storageName },
    });
    document.dispatchEvent(customEvent);
  }

  onAddExchangeRate() {
    // send gridId to identify which grid triggered the event
    const customEvent = new CustomEvent('addExchangeRateClick', {
      detail: { data: this.params, gridId: this.params?.context?.storageName },
    });
    document.dispatchEvent(customEvent);
  }

}
